import React, { useRef, useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import "./printStyle.css";
import Signature from "../assets/signature.jpeg";
import { useListSettings } from "../component/api/setting";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const PrintLayout = ({ html, data, category }) => {
  const printRef = useRef(null);
  const navigate = useNavigate();

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const { data: settings } = useListSettings();

  useEffect(() => {
    if (!userInfo) {
      navigate("/signin");
    }
  }, [userInfo, navigate]);

  const printAction = () => {
    const printContent = printRef.current;
    const printWindow = window.open("", "_blank");

    printWindow.document.open();
    printWindow.document.write(`
      <html>
        <head>
          <style>
            body {
              margin: 0;
              padding: 0;
              line-height : 1;
              font-family: Arial, sans-serif;
              position : relative;
            }
            .print-container {
              display: flex;
              flex-direction: column;
              min-height: 100vh;
              z-index: 1;
              width : 100%;
            }
            .signature {
               position : fixed;
               bottom : 400px;
               right : 110px;  
               width :100px; 
               text-align : right;
            }  

            th, td {
              padding : 8px;
            }

            .header, .footer {
              position :fixed;
               z-index : 9999;
               display : block;
              width: 100%;
              text-align: center;
              object-fit : fill;
            }
              .header {
                top : 0px;
                height : ${category !== "expense" && category !== "forms"
        ? "300px"
        : "170px"
      };
               
                
              }
            .content {
              flex: 1;
              margin:2cm;
              margin: 0 auto;
              z-index: 1;
            }
            table {
              width: 100%;
              border-collapse: collapse;
            }
            
            th {
           
              text-align: center;
            }

            .flex {
             display : flex;
             width: 100%;
             justif-content : space-between;
             alignItems : center;
             gap : 90px;
            }

            .backgroundLogo {
                position : fixed;
               margin-left: auto;
               left: 0;
                bottom : 180px;
            text-align: left;
             z-index: -1;
             width : 14rem;
            }
            
            div,table{
              font-size: ${settings?.data?.textSize || 16}px;
            }

            table.report-container {
              page-break-after:always;
              }
        thead.report-header {
               display:table-header-group;
           }
            tfoot.report-footer {
               display:table-footer-group;
                 } 

        tbody.main {
               margin-top : 300px;

         }

            @media print {
          
             ${category == "expense"
        ? "@page { margin: 0; size: A5  }"
        : " @page { margin: 0; size: A4 }"
      }
             body { 
             width : 1230px;
            background-image: url(${settings?.data?.[`${category}`]?.logo || ''}); /* Inline base64 image for print */
           
          }
              
            
          .header {
            position : fixed;
            display : block;
            height: ${category !== "expense" && category !== "forms" ? "300px" : "170px"
      };
            z-index:9999;  
            
             
          }
               
              .print-button {
                display: none;
              }
             
              .content {
                position :sticky;
               width: 90%;
                  -webkit-box-decoration-break: clone;
               box-decoration-break: clone;
                  margin-top :  ${category !== "expense" && category !== "forms"
        ? "270px"
        : "150px"
      };
               display :block;
               z-index: 1;
              
              }
              .footer {
               position:fixed;
               
              
                display: block;
                bottom: 0;
                padding-top : 20px;
                z-index:9999; 
              }

          </style>
        </head>
        <body>
        <table class="report-container">
        <thead class="report-header">
     <tr>
        <th class="report-header-cell">
           <div class="header-info header">
              ${settings?.data?.[`${category}`]?.header
        ? `<img src=${settings.data[`${category}`]?.header
        }  class="header" />`
        : ""
      }

          <tfoot class="report-footer footer">
      <tr>
         <td class="report-footer-cell">
           
             ${settings?.data?.[`${category}`]?.footer
         ? `<img src="${settings.data[`${category}`]?.footer
              }"  class="footer" />`
        : ""
      }
               <tbody class="report-content content">
      <tr>
        
         <td class="report-content-cell">
            <div class="main" >
              ${html(data)}
              <div style="margin : 20px;">
                ${category === 'prescription' ? `
                  <div style="width: 100%; display :flex; justify-content : right; " >
                  <img src=${Signature} style="width: 110px;" ></img>
                  </div>
               ` : ''}
                </div>
            </div>
          </td>
       
       </tr>
     </tbody>
           
          </td>
      </tr>
    </tfoot>
           
           
           </div>
         </th>
      </tr>
    </thead>
        </table>


       
        </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.onload = () => {
      printWindow.print();
      printWindow.close();
    };
  };

  return (
    <div ref={printRef}>
      <div className="print-button d-flex justify-content-end mt-3 ">
        <Button variant="primary" onClick={printAction}>
          Print
        </Button>
      </div>
    </div>
  );
};

export default PrintLayout;
